/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers';
import type { Provider, TransactionRequest } from '@ethersproject/providers';
import type { PromiseOrValue } from '../common.js';
import type { LidoBridge, LidoBridgeInterface } from '../LidoBridge.js';

const _abi = [
  {
    inputs: [
      {
        internalType: 'address',
        name: '_rollupProcessor',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_referral',
        type: 'address',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    inputs: [],
    name: 'AsyncDisabled',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidCaller',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidConfiguration',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidInputA',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidOutputA',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidUnwrapReturnValue',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidWrapReturnValue',
    type: 'error',
  },
  {
    inputs: [],
    name: 'MissingImplementation',
    type: 'error',
  },
  {
    inputs: [],
    name: 'CURVE_POOL',
    outputs: [
      {
        internalType: 'contract ICurvePool',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'LIDO',
    outputs: [
      {
        internalType: 'contract ILido',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'REFERRAL',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'ROLLUP_PROCESSOR',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'SUBSIDY',
    outputs: [
      {
        internalType: 'contract ISubsidy',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'WRAPPED_STETH',
    outputs: [
      {
        internalType: 'contract IWstETH',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        internalType: 'uint64',
        name: '',
        type: 'uint64',
      },
    ],
    name: 'computeCriteria',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '_inputAssetA',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '_outputAssetA',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        internalType: 'uint256',
        name: '_totalInputValue',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '_interactionNonce',
        type: 'uint256',
      },
      {
        internalType: 'uint64',
        name: '',
        type: 'uint64',
      },
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    name: 'convert',
    outputs: [
      {
        internalType: 'uint256',
        name: 'outputValueA',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: 'isAsync',
        type: 'bool',
      },
    ],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
      {
        internalType: 'uint64',
        name: '',
        type: 'uint64',
      },
    ],
    name: 'finalise',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    stateMutability: 'payable',
    type: 'receive',
  },
];

const _bytecode =
  '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';

type LidoBridgeConstructorParams = [signer?: Signer] | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (xs: LidoBridgeConstructorParams): xs is ConstructorParameters<typeof ContractFactory> =>
  xs.length > 1;

export class LidoBridge__factory extends ContractFactory {
  constructor(...args: LidoBridgeConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _rollupProcessor: PromiseOrValue<string>,
    _referral: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> },
  ): Promise<LidoBridge> {
    return super.deploy(_rollupProcessor, _referral, overrides || {}) as Promise<LidoBridge>;
  }
  override getDeployTransaction(
    _rollupProcessor: PromiseOrValue<string>,
    _referral: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> },
  ): TransactionRequest {
    return super.getDeployTransaction(_rollupProcessor, _referral, overrides || {});
  }
  override attach(address: string): LidoBridge {
    return super.attach(address) as LidoBridge;
  }
  override connect(signer: Signer): LidoBridge__factory {
    return super.connect(signer) as LidoBridge__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): LidoBridgeInterface {
    return new utils.Interface(_abi) as LidoBridgeInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): LidoBridge {
    return new Contract(address, _abi, signerOrProvider) as LidoBridge;
  }
}
